import { FC, PropsWithChildren, useMemo } from 'react';

import { Box, Button, Flex } from '@chakra-ui/react';
import { bracketsSecondChancePath } from '@/modules/Bracket/bracket.constants';
import { useAppSelector } from '@/store';
import { usePathToBracket } from '@/modules/Bracket/hooks/usePathToBracket';
import { useGameDate } from '@/hooks/useGameDate';
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { editSCPath } from '@/modules/Bracket/bracket.helpers';
import { tKeys } from '@/i18n';
import { BracketMode } from '@/modules/Bracket/brackets.enums';
import { SearchParamsEnum } from '@/enums/searchParams.enum';

export const MobileHeaderWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { pathname } = useLocation();
  const { isLive, isSecondChanceLive } = useGameDate();
  const { bracketPathById } = usePathToBracket();
  const [searchParams] = useSearchParams();

  const { user, entrySC } = useAppSelector((state) => state.bracket);

  const isSecondChancePage = pathname === bracketsSecondChancePath();

  const isEditButtonVisible = useMemo(() => {
    if (isSecondChancePage) {
      return (
        Number(user?.user_id) === Number(entrySC?.user_id) && isSecondChanceLive
      );
    }
    return isLive;
  }, [
    entrySC?.user_id,
    isLive,
    isSecondChanceLive,
    isSecondChancePage,
    user?.user_id,
  ]);
  const bracketViewType =
    (searchParams.get(SearchParamsEnum.viewType) as BracketMode) ||
    BracketMode.view;

  return (
    <>
      {/* Note: This component placed under Layout/Header */}
      <Flex
        alignItems='center'
        bgColor='darkBlue'
        gap='13px'
        h='87px'
        left='0'
        position='fixed'
        px='8px'
        top='0'
        w='calc(100vw - 50px)' // should overlay content, but not menu button
        zIndex='999' // +1 to Layout/Header
      >
        {children}
        {bracketViewType !== BracketMode.edit && isEditButtonVisible && (
          <Button
            as={Link}
            to={isSecondChancePage ? editSCPath() : bracketPathById(id)}
            size='sm'
            w='94px'
            fontSize='16px'
            variant='outline'
            border='2px solid #7D8990'
            bg='transparent'
            mt='5px'
            py='5px'
            rightIcon={
              <svg
                fill='none'
                height='16'
                viewBox='0 0 17 16'
                width='17'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2.5 11.4997V13.9997H5L12.3733 6.62638L9.87333 4.12638L2.5 11.4997ZM14.3067 4.69305C14.5667 4.43305 14.5667 4.01305 14.3067 3.75305L12.7467 2.19305C12.4867 1.93305 12.0667 1.93305 11.8067 2.19305L10.5867 3.41305L13.0867 5.91305L14.3067 4.69305Z'
                  fill='white'
                />
              </svg>
            }
          >
            {t(tKeys.edit)}
          </Button>
        )}
      </Flex>
    </>
  );
};

export const SubHeaderWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      {/* Note: This component placed under Layout/Header */}
      <Box
        bgColor='#071520'
        left='0'
        position='fixed'
        px='8px'
        top='87px'
        w='calc(100vw)'
        zIndex='998' // same as Layout/Header
      >
        {children}
      </Box>
    </>
  );
};
